export function formatIDR(value) {
  const n = Number(value || 0);
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n);
}

export function formatNumber(value) {
  return new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(Number(value || 0));
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function daysBetween(a, b) {
  const da = new Date(a + "T00:00:00");
  const db = new Date(b + "T00:00:00");
  return Math.round((db - da) / (1000 * 60 * 60 * 24));
}

export function terbilang(n) {
  // Convert integer to Indonesian words (for kwitansi)
  n = Math.floor(Math.abs(Number(n || 0)));
  const satuan = ["", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan", "sepuluh", "sebelas"];
  function t(x) {
    if (x < 12) return satuan[x];
    if (x < 20) return satuan[x - 10] + " belas";
    if (x < 100) return satuan[Math.floor(x / 10)] + " puluh" + (x % 10 ? " " + satuan[x % 10] : "");
    if (x < 200) return "seratus" + (x - 100 ? " " + t(x - 100) : "");
    if (x < 1000) return satuan[Math.floor(x / 100)] + " ratus" + (x % 100 ? " " + t(x % 100) : "");
    if (x < 2000) return "seribu" + (x - 1000 ? " " + t(x - 1000) : "");
    if (x < 1_000_000) return t(Math.floor(x / 1000)) + " ribu" + (x % 1000 ? " " + t(x % 1000) : "");
    if (x < 1_000_000_000) return t(Math.floor(x / 1_000_000)) + " juta" + (x % 1_000_000 ? " " + t(x % 1_000_000) : "");
    return t(Math.floor(x / 1_000_000_000)) + " milyar" + (x % 1_000_000_000 ? " " + t(x % 1_000_000_000) : "");
  }
  if (n === 0) return "nol rupiah";
  return t(n).replace(/\s+/g, " ").trim() + " rupiah";
}
